import { Component } from '@angular/core';
import {Directionality} from '@angular/cdk/bidi';
import {ChangeDetectorRef} from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';

import { PriceWeightService } from '../_services/price-weight.service';

@Component({
  selector: 'app-custom-stepper',
  templateUrl: './custom-stepper.component.html',
  styleUrls: ['./custom-stepper.component.scss'],
    providers: [{provide: CdkStepper, useExisting: CustomStepperComponent}],
})

export class CustomStepperComponent extends CdkStepper {

    constructor(
        dir: Directionality,
        changeDetectorRef: ChangeDetectorRef,
        private priceWeight: PriceWeightService,
    ) {
        super(dir, changeDetectorRef);
    }

    onClick(index: number): void {
      this.selectedIndex = index;
    }

    get weight() {
        return this.priceWeight.weight;
    }

    get price() {
        return this.priceWeight.price;
    }
}
